import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Control from "../Control";

const Textarea = ({
    invalidFields,
    label,
    id,
    error,
    name,
    defaultValue,
    required,
    isEmpty,
    classes,
    ...otherProps
}) => {
    const [value, setValue] = useState(defaultValue);

    const onChange = (event) => {
        setValue(event.target.value);
        if (typeof otherProps.onChange === "function") {
            otherProps.onChange(event);
        }
    };

    let _isEmpty = true;

    if (
        (typeof value === "string" && value.length > 0) ||
        (typeof value === "number" && value)
    ) {
        _isEmpty = false;
    }

    if (isEmpty) {
        _isEmpty = true;
    }

    return (
        <Control
            id={id}
            label={label}
            error={error}
            name={name}
            required={required}
            invalidFields={invalidFields}
            classes={{
                container: classNames(`form-input--textarea`, {
                    "form-input--filled": !_isEmpty,
                }),
                ...classes,
            }}
        >
            <textarea
                name={name}
                id={id}
                className="form-input__input"
                rows="4"
                required={required}
                defaultValue={defaultValue || ``}
                onChange={onChange}
                {...otherProps}
            />
        </Control>
    );
};

Textarea.propTypes = {
    defaultValue: PropTypes.string,
    ...Control.propTypes,
};

export default Textarea;
